
import { defineStore, acceptHMRUpdate } from 'pinia'
import { userRepository } from '../utils/loginRepository';

import {
    RecaptchaVerifier,
    signInWithPhoneNumber,
    type ConfirmationResult,
    signOut,
    updatePhoneNumber,
    PhoneAuthProvider

} from 'firebase/auth'
import { useAuthStore } from './auth';
import { useUserStore } from './user';

export const useLoginStore = defineStore('login', () => {
    const isOTP = ref(false);
    const error = ref()
    const auth = useFirebaseAuth()!
    const myConfirmationResult = ref<ConfirmationResult | void>()
    const router = useRouter();
    const route = useRoute();
    const userRepo = userRepository();
    const authStore = useAuthStore();
    const userStore = useUserStore();
    const verificationId = ref<string>();
    const isPhoneEdit = ref(false)
    const isLoading = ref(false);
    function sendOTP(phoneNumber: string) {
        error.value = undefined
        isLoading.value = true
        const recapta = new RecaptchaVerifier(auth, 'recaptcha-container', {
            'size': 'invisible',
            'callback': (response: any) => {
                console.log(response)
            },
            'expired-callback': () => {
            }
        });

        signInWithPhoneNumber(auth, '+91' + phoneNumber, recapta).catch((reason) => {
            console.error('Failed signinRedirect', reason)
            console.log(reason)
            error.value = 'Failed signinRedirect ' + reason
            // error.value = reason
        }).then((confirmationResult) => {
            console.log(confirmationResult)
            isOTP.value = !isOTP.value
            myConfirmationResult.value = confirmationResult;
        }).catch((error) => {
            console.error('Failed signinRedirect', error)
            console.log(error)
            error.value = 'Failed signinRedirect ' + error
            // error.value = error
        }).finally(() => {
            isLoading.value = false
        })
    }
    async function verifyOTP(otp: string) {
        try {
            isLoading.value = true
            const result = await myConfirmationResult.value?.confirm(otp);
            const token = await result?.user.getIdToken()
            const phoneNumber = useCurrentUser()?.value?.phoneNumber ?? '';
            if (token === undefined || phoneNumber === '') {
                error.value = 'Failed to receive token. Please try again (#FB0001)'
                return
            }
            const mtoken = await reciveToken(token, phoneNumber)
            if (mtoken === undefined) {
                error.value = 'Failed to receive token. Please try again (#SE0002)'
                return
            }
            authStore.setToken(mtoken);
            const user = await userStore.receiveUser()
            if (!user || user === undefined) {
                error.value = 'Failed to receive user Please try again (#SE0003)'
                return
            }
            error.value = undefined

            let redirectTo = route.query.redirect;
            // Ensure redirectTo is a string
            if (Array.isArray(redirectTo)) {
                redirectTo = redirectTo[0];
            }
            if (typeof redirectTo !== 'string') {
                redirectTo = '/';
            }
            isLoading.value = false
            // Redirect to the specified route
            await router.replace(redirectTo);

            isOTP.value = false
        } catch (error) {
            console.error(error);
            isLoading.value = false
        }
    }

    async function updatePhoneNumberFirebase(phoneNumber: string) {
        try {
            const applicationVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
                'size': 'invisible',
                'callback': (response: any) => {
                    console.log(response)
                },
                'expired-callback': () => {
                }
            });
            const provider = new PhoneAuthProvider(auth);
            verificationId.value = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
            if (verificationId.value) {
                isPhoneEdit.value = true
                isOTP.value = true
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function verifyUpdatePhoneNumber(otp: string) {
        if (!verificationId.value) return
        if (!otp && otp.length < 4) return
        const phoneCredential = PhoneAuthProvider.credential(verificationId.value, otp);
        await updatePhoneNumber(auth.currentUser!, phoneCredential);
        console.log(auth.currentUser);
        const phoneNumber = useCurrentUser()?.value?.phoneNumber ?? '';
        const token = await auth.currentUser?.getIdToken()
        if (token === undefined || phoneNumber === '') {
            error.value = 'Failed to receive token. Please try again (#FB0001)'
            return
        }
        const useInfo = userStore.user
        useInfo!.phone = phoneNumber;
        useInfo!.firebaseToken = token
        const result = await userStore.updateUser(useInfo!)
        if (result !== 'ok') {
            isOTP.value = false
            error.value = 'username id does not match or firebase toke issue'
            return
        }
        isPhoneEdit.value = false
        isOTP.value = false
        const user = await userStore.receiveUser()
        if (!user || user === undefined) {
            error.value = 'Failed to receive user Please try again (#SE0003)'
            return
        }
        error.value = undefined
    }

    function isSignedIn() {
        return !!auth.currentUser
    }


    async function reciveToken(token: string, telephone: string) {
        try {
            const data = await userRepo.register(undefined, undefined, telephone, token);
            console.log(data);
            if (data.code === 200) {
                return data.data.token
            }
        } catch (reason) {
            console.error('Error during registration:', reason);
        }
    }

    function signOutApp() {
        signOut(auth).catch((reason) => {
            console.log(reason)
        }).then(() => {
            clearEveryThing()
            router.replace('/')
        })
    }

    function reset() {
        isOTP.value = false
        error.value = undefined
        isPhoneEdit.value = false
        verificationId.value = undefined
    }

    function clearEveryThing() {
        useAuthStore().reset()
        useCartStore().reset()
        useOrderStore().reset()
        useUserStore().reset()
        useWishlistStore().reset()
        reset()

    }

    return {
        sendOTP,
        verifyOTP,
        isOTP,
        error,
        isPhoneEdit,
        isLoading,
        signOutApp,
        isSignedIn,
        updatePhoneNumberFirebase,
        verifyUpdatePhoneNumber,
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useLoginStore, import.meta.hot))
}
